<button (click)="createFilter(filterTypes.SPATIAL)"
        color="primary"
        i18n-tmTooltip="@@core.filter.create-new-spatial-filter"
        mat-flat-button
        tmTooltip="Create new spatial filter">
  <mat-icon svgIcon="plus"></mat-icon>
  <span i18n="@@core.filter.spatial-filter">Spatial filter</span>
</button>
